import { useState, useEffect, useRef } from 'react';
import { GetLocationOptions } from '../../../../ApplicationInformation/ApplicationInformation_api';
import styles from '../AppForms/UPMCApplicationForm/UPMCApplicationForm.module.scss';
import classNames from 'classnames';
import HtmlLinkButton from './UPMCApplicationForm/HtmlLinkButton';
import LocationsEdit from './UPMCApplicationForm/LocationsEdit';
import ContactsEdit from './UPMCApplicationForm/ContactsEdit';
import ApplicationTypeDropdown from './UPMCApplicationForm/ApplicationTypeDropdown';

//param @app : AppManagementModel
//param @setApp : function
const UPMCApplicationForm = ({ app, setApp }) => {
	const [locationOptions, setLocationOptions] = useState([]);

	const [activeElement, setActiveElement] = useState(null);
	const descriptionRef = useRef();
	const shortdescriptionRef = useRef();
	const aliasRef = useRef();
	const typicalUsersRef = useRef();
	const trainingRef = useRef();
	const quickStartRef = useRef();

	const helpRef = useRef();
	const addInfoRef = useRef();
	const managingdeptRef = useRef();

	useEffect(() => {
		GetLocationOptions().then(response => {
			let locations = response;
			setLocationOptions(locations);
		});
	}, []);

	const resolveTextAreaNull = value => {
		if (value === null) {
			return '';
		} else return value;
	};

	const handleChange = e => {
		setApp({
			...app,
			UPMCApplication: {
				...app.UPMCApplication,
				[e.target.name]: e.target.value,
			},
		});
	};

	return (
		<>
			<p>Application Type</p>
			<ApplicationTypeDropdown app={app} setApp={setApp} />
			<div className={styles.AppDetailsSection}>
				<div
					className={classNames([styles.description, styles.section])}
				>
					<div className={styles.detailLabel}>
						<p>
							Description{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication?.description?.length
									? app.UPMCApplication?.description?.length
									: 0}
								/{2048})
							</span>
						</p>
					</div>

					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.description
						)}
						onChange={e => handleChange(e)}
						name='description'
						maxLength={2048}
						ref={descriptionRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={descriptionRef}
						className={styles.mdLinkButton}
						handleChange={handleChange}
						activeElement={activeElement}
					/>
				</div>

				<div
					className={classNames([
						styles.shortDescription,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>
						<p>
							Short Description{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication.shortDescription?.length
									? app.UPMCApplication.shortDescription
											?.length
									: 0}{' '}
								/{128})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.shortDescription
						)}
						onChange={e => handleChange(e)}
						name='shortDescription'
						maxLength={128}
						ref={shortdescriptionRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={shortdescriptionRef}
						className={styles.mdLinkButton}
						handleChange={handleChange}
						activeElement={activeElement}
					/>
				</div>

				<div className={classNames([styles.alias, styles.section])}>
					<div className={styles.detailLabel}>
						<p>
							Alias{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication.alias?.length
									? app.UPMCApplication.alias?.length
									: 0}
								/{255})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(app.UPMCApplication.alias)}
						onChange={e => handleChange(e)}
						name='alias'
						maxLength={255}
						ref={aliasRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
				</div>

				<div className={classNames([styles.training, styles.section])}>
					<div className={styles.detailLabel}>
						<p>
							Training Information{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication.training?.length
									? app.UPMCApplication.training?.length
									: 0}
								/{512})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.training
						)}
						onChange={e => handleChange(e)}
						name='training'
						maxLength={512}
						ref={trainingRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={trainingRef}
						className={styles.mdLinkButton}
						handleChange={handleChange}
						activeElement={activeElement}
					/>
				</div>

				<div
					className={classNames([
						styles.typicalUsers,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>
						<p>
							Typical Users{' '}
							<span className={styles.characterCount}>
								(
								{app?.UPMCApplication?.typicalUsers?.length
									? app?.UPMCApplication?.typicalUsers?.length
									: 0}
								/{128})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.typicalUsers
						)}
						onChange={e => handleChange(e)}
						name='typicalUsers'
						maxLength={128}
						ref={typicalUsersRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
				</div>

				<div
					className={classNames([styles.quickStart, styles.section])}
				>
					<div className={styles.detailLabel}>
						<p>
							Next Steps{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication.quickStart?.length
									? app.UPMCApplication.quickStart?.length
									: 0}
								/{512})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.quickStart
						)}
						onChange={e => handleChange(e)}
						name='quickStart'
						maxLength={512}
						ref={quickStartRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={quickStartRef}
						className={styles.mdLinkButton}
						handleChange={handleChange}
						activeElement={activeElement}
					/>
				</div>
				<div className={classNames([styles.locations, styles.section])}>
					<div className={styles.detailLabel}>Locations </div>
					<LocationsEdit
						copyOfApp={app}
						setCopyOfApp={setApp}
						locationOptions={locationOptions}
					/>
				</div>
				<div className={classNames([styles.help, styles.section])}>
					<div className={styles.detailLabel}>
						<p>
							Support{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication.help?.length
									? app.UPMCApplication.help?.length
									: 0}
								/{255})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(app.UPMCApplication.help)}
						onChange={e => handleChange(e)}
						name='help'
						maxLength={255}
						ref={helpRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={helpRef}
						className={styles.mdLinkButton}
						handleChange={handleChange}
						activeElement={activeElement}
					/>
				</div>

				<div
					className={classNames([
						styles.additionalInformation,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>
						<p>
							Additional Information{' '}
							<span className={styles.characterCount}>
								(
								{app?.UPMCApplication?.additionalInformation
									?.length
									? app?.UPMCApplication
											?.additionalInformation?.length
									: 0}
								/{256})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.additionalInformation
						)}
						onChange={e => handleChange(e)}
						name='additionalInformation'
						maxLength={256}
						ref={addInfoRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={addInfoRef}
						className={styles.mdLinkButton}
						handleChange={handleChange}
						activeElement={activeElement}
					/>
				</div>

				<div
					className={classNames([
						styles.managingDepartment,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>
						<p>
							Managing Department{' '}
							<span className={styles.characterCount}>
								(
								{app.UPMCApplication.managingDepartment?.length
									? app.UPMCApplication.managingDepartment
											?.length
									: 0}
								/{64})
							</span>
						</p>
					</div>
					<textarea
						className={classNames([
							styles.detailInfo,
							styles.textArea,
						])}
						type='text'
						value={resolveTextAreaNull(
							app.UPMCApplication.managingDepartment
						)}
						onChange={e => handleChange(e)}
						name='managingDepartment'
						maxLength={64}
						ref={managingdeptRef}
						rows={5}
						onFocus={e => setActiveElement(e.target)}
					/>
					<HtmlLinkButton
						refElement={managingdeptRef}
						activeElement={activeElement}
						className={styles.mdLinkButton}
						handleChange={handleChange}
					/>
				</div>

				<div
					className={classNames([
						styles.securityContact,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Security Contact</div>

					<ContactsEdit
						copyOfApp={app}
						setCopyOfApp={setApp}
						contactTypeKey='securityContact'
						buttonLabel='Edit Security Contacts'
					/>
				</div>

				<div
					className={classNames([
						styles.privacyContact,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Privacy Contact</div>
					<ContactsEdit
						copyOfApp={app}
						setCopyOfApp={setApp}
						contactTypeKey='privacyContact'
						buttonLabel='Edit Privacy Contacts'
					/>
				</div>

				<div className={classNames([styles.owners, styles.section])}>
					<div className={styles.detailLabel}>Owners</div>

					<ContactsEdit
						copyOfApp={app}
						setCopyOfApp={setApp}
						contactTypeKey='owners'
						buttonLabel='Edit Owners'
					/>
				</div>

				<div
					className={classNames([
						styles.technicalTeam,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Technical Team</div>
					<ContactsEdit
						copyOfApp={app}
						setCopyOfApp={setApp}
						contactTypeKey='technicalTeam'
						buttonLabel='Edit Technical Team'
					/>
				</div>
			</div>
		</>
	);
};

export default UPMCApplicationForm;
